<template>
  <div class="app-forgot-password-sms-code">
    <dyn-slot :slot-data="slotData">
      <slot name="txtBefore">
          <p>Wir haben Ihnen einen Code zukommen lassen. Bitte tragen Sie diesen in das folgende Feld ein, um Ihr
            Passwort ändern zu können.</p>
      </slot>
    </dyn-slot>
    <b-form
      inline
      @submit.prevent="next()"
      :id="'form' + _uid"
      :novalidate="true"
    >
      <label class="col-form-label label-before" :for="'sms-code-' + _uid">
        <dyn-slot :slot-data="slotData">
          <slot name="lblBefore"></slot>
        </dyn-slot>
      </label>
      <b-form-group :id="'sms-code-' + _uid" class="form-group-sms-code">
        <label class="col-form-label label-sms-code" :for="'sms-code-' + _uid">
          <dyn-slot :slot-data="slotData">
            <slot name="lblSMSCode">Eingabe SMS Code:</slot>
          </dyn-slot>
        </label>
        <b-form-input
          type="text"
          required
          name="code"
          v-model="code"
          @input="$v.code.$touch"
          :state="isValid('code')"
        ></b-form-input>
        <b-form-invalid-feedback v-if="displayErrorMessage">
          Sie haben keinen gültigen Code angegeben
        </b-form-invalid-feedback>
      </b-form-group>
      <b-button :id="'submit-'+_uid" type="submit" variant="primary" class="sms-code-next" :disabled="$v.$invalid">
        <slot name="btnNext">weiter</slot>
      </b-button>
    </b-form>
    <dyn-slot :slot-data="slotData">
      <slot name="txtAfter"></slot>
    </dyn-slot>
  </div>
</template>

<script>
import { BButton, BForm, BFormGroup, BFormInput, BFormInvalidFeedback } from 'bootstrap-vue'
import { validationMixin } from 'vuelidate'
import { maxLength, minLength, required } from 'vuelidate/lib/validators'
import { mapMutations } from 'vuex'
import isValid from '../../../../../mixins/isValid'

export default {
  name: 'ResetPasswordConfirmationToken',
  data () {
    return {
      code: '',
      displayErrorMessage: false
    }
  },
  props: {
    minTokenLength: {
      type: Number,
      default: 8
    },
    maxTokenLength: {
      type: Number,
      default: 8
    }
  },
  components: {
    BButton, BFormGroup, BFormInput, BForm, BFormInvalidFeedback
  },
  methods: {
    next () {
      if (this.$v.$invalid) {
        return
      }
      this.captureToken(this.code)
    },
    ...mapMutations('resetPassword', [
      'captureToken'
    ])
  },
  mixins: [validationMixin, isValid],
  validations () {
    return {
      code: {
        required,
        minLength: minLength(this.minTokenLength),
        maxLength: maxLength(this.maxTokenLength)
      }
    }
  },
  computed: {
    slotData () {
      return {
        code: this.code,
        displayErrorMessage: this.displayErrorMessage
      }
    }
  }
}
</script>
